<template><div><h1 id="auftragseingang-nach-zeitraum-und-medium" tabindex="-1"><a class="header-anchor" href="#auftragseingang-nach-zeitraum-und-medium"><span>Auftragseingang nach Zeitraum und Medium</span></a></h1>
<p>Auftragseingang nach Zeitraum und Medium — Listet Bestellwert und Anzahl Aufträge pro Tag</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste aus Aufträgen. Es kann nach Auftragsarten und Medien eingegrenzt werden. Die Liste zeigt die Bestellwerte und die Anzahl der Aufträge pro Tag kumuliert.</p>
<p>Pfad:</p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Erfassungsdatum von</dt>
<dd>Muss-Eingabe, inklusive</dd>
<dt>Erfassungsdatum bis</dt>
<dd>Muss-Eingabe, inklusive</dd>
<dt>Auftragsarten</dt>
<dd>mit Kommas trennen, ohne Leerzeichen, *=alles, Muss-Eingabe</dd>
<dt>Medien</dt>
<dd>mit Kommas trennen, ohne Leerzeichen, *=alles, Muss-Eingabe</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Datum</td>
<td>Erfassungsdatum</td>
</tr>
<tr>
<td>Bestellwert</td>
<td>Brutto-Erlös pro Tag [Datum] (inkl. Spenden, Versandkosten, MWST)</td>
</tr>
<tr>
<td>Anzahl</td>
<td>Aufträge pro Tag [Datum]</td>
</tr>
</tbody>
</table>
<p>09.01.98        100     7       01.01.98-30.09.98       Auftragsarten: pav 29.01.98        32.5    3                                      Medien: *
30.01.98        18      3
12.03.98        6       2
16.03.98        5.5     2
24.03.98        25      1
31.03.98        53      1
.
.</p>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Spendeartikel werden in dieser Statistik nicht mitgezählt.</p>
</div>
</div></template>


